import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './styles.css';
import { testimonialsData } from '../../data/testimonials';

export default function Testimonials() {
  return (
    <section id="container-testimonials">
      <div id="content-testimonials">
        <h2>O que nossos membros dizem</h2>
        <Swiper
          // Módulos do Swiper
          modules={[Navigation, Pagination, A11y]}
          spaceBetween={30}
          slidesPerView={1}
          navigation 
          pagination={{ clickable: true }} 
          loop={true} 
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 25
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          }}
          className="mySwiper"
        >
          {testimonialsData.map((testimonial) => (
            <SwiperSlide key={testimonial.id}>
              <div className="testimonial-card">
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-footer">
                  <img src={testimonial.image} alt={`Foto de ${testimonial.name}`} />
                  <div className="author-info">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.course}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}